import React , {useState , useReducer , useEffect} from 'react';

//images
import recapImage from '../img/recapitulatif.png';
import recapImageMobile from '../img/recapitulatif-mobile.svg';
import croix from '../img/croix.svg';
import profil from '../img/profil.svg';
import crayon from '../img/crayon.svg';
import coeur from '../img/coeur.svg';
import famille from '../img/famille.svg';
import maison from '../img/maison.svg';
import euros from '../img/euros.svg';

export default function Recap ( props ) {

    const [ show , setDisplay ] = useState(false);
    const {data}  = props;
    const recapData = {
      profil: {
        title: 'Profil',
        icon_img: profil,
        page: 2,
      },
      conjoint: {
        title: 'Conjoint(e)',
        page: 3,
        icon_img: coeur,
      },
      enfants_a_charge: {
        title: 'Mes enfants à charge',
        page: 4,
        icon_img: famille,
      },
      logement: {
        title: 'Mon logement',
        icon_img: maison,
        page: 5,
      },
      ressources: {
        title: 'Ressources',
        page: 6,
        icon_img: euros,
      }
    };

    const reducer = ( state , action ) => {
        state = { ...state , [action.key] : action.value}
        return state;
    }

    const [availableDatas , updateAvailableDatas] = useReducer ( reducer , {
        profil : [],
        conjoint : [],
        enfants_a_charge : [],
        logement : [],
        ressources : []
    });

    const setStep = (newStep)=>{
        data.setStep(newStep);
    };

    const setAvailableDatas = (newData)  =>{
        const key  = Object.keys(newData)[0];
        updateAvailableDatas( { 'key': key, 'value':newData[key]});
    };

    const initDataProfil = ()=> {
        let profil = [];
        if (data.demandeur){
            if (!isNaN(data.demandeur.age)) {
                const {age} = data.demandeur;
                profil.push( <><b>{age}</b> ans</>)
            }
        }
        setAvailableDatas({profil});
    }

    const initDataConjoint = ()=>{
        let conjoint = []
        if (data.demandeur && !data.demandeur.enCouple) {
            conjoint= [<>Vous vivez seul(e)</>];
        } else if (data.demandeur && data.demandeur.enCouple) {
            if (data.conjoint && data.conjoint.age){
                const ageConjoint = data.conjoint.age;
                conjoint.push( <><b>{ageConjoint}</b> ans</>)
            }
        }
        setAvailableDatas (  {conjoint});
    }
    
    const initDataEnfants = ()=>{
        let enfants_a_charge =[];
        if (data.enfants) {
            const { hasEnfantGardeAlternee , nombreEnfant , nombreEnfantGardeAlternee} = data.enfants;
            enfants_a_charge.push( <><b>{nombreEnfant}</b> enfants à charge</>);
        
            if (hasEnfantGardeAlternee){
                enfants_a_charge.push( <><b>{nombreEnfantGardeAlternee}</b>enfants en garde alternée</>)
            }
        }
        setAvailableDatas({enfants_a_charge})

    }

    const initDataLogement = () => {
        let logement = [];
        if (data.logement){
            const situationLogementMap= {'proprietaire' : "Propriétaire",
                'sans_domicile' : "Sans domicile stable",
                'loge_gratuitement': "Hébergé",
                'locataire_vide': "Locataire"
            };
            if (data.logement.situationLogement){
                const situation = situationLogementMap[data.logement.situationLogement];
                logement.push(<><b>{situation}</b></>);
            }
            
        }
        
        setAvailableDatas({logement});
    }
    
    const initDataRessources = () => {
        let ressources = [];
        if(data.ressources){

        }
        setAvailableDatas({ressources});
    }

    const initRecapData = ()=>{
        initDataProfil();
        initDataConjoint();
        initDataEnfants();
        initDataLogement();
        initDataRessources();
    }

    useEffect ( initRecapData , []);

    return <> 
        {  (!show)?
            <div className='recapitulation-button' onClick={ ()=>setDisplay(!show)}>
                <div className='btn-txt'>
                    <span>Cliquez ici pour modifier</span>
                    <span>les informations</span>
                    <span>déjà saisies</span>
                </div>
                <div className='btn-img'>
                    <img src={recapImage} id="recap-image-desktop"/>
                    <img src={recapImageMobile} id="recap-image-mobile"/>
                </div>
            </div>
    
            :
            <div id="recap-component" ng-show="afficher_recap" className="">
                <div>
                    <div>
                        <span>Récapitulatif</span>
                    </div>
                    <div>
                        <img src={croix} alt="Croix" onClick={()=>{setDisplay(!show)}}/>
                    </div>
                </div>
                <div className="row">
                    {
                    Object.keys(recapData).map( (dataKey) => {
                        const  dataRecap = recapData[dataKey];
                        const infos = availableDatas[dataKey];
                        return <div className="col-6 col-sm-4 recap-info">
                            <div>
                                <img src={dataRecap.icon_img} />
                                <span>{dataRecap.title}</span>
                            </div>
                            <div>
                                {!infos.length ?
                                    <small> Aucune information saisie </small>
                                    :<div className="data">
                                        { infos.map( (info)=> info )}
                                    </div>
                                }
                            </div>
                            <div class="edit-btn">
                                <img src={crayon} alt="Modifier" />
                                <a onClick={ () => setStep(dataRecap.page)}>Modifier</a>
                            </div>
                        </div>
                    })
                    }
                </div>
            </div>

        }
    </>
}